import React from "react";

function SolutionCard({ cardDetails }) {
  console.log(cardDetails);
  return (
    <div className="w-full flex justify-center gap-x-10 gap-y-5 flex-wrap">
      {cardDetails.map((card) => {
        return (
          <div
            key={card.id}
            className="flex justify-center items-center"
          >
            <div className="md:w-60 md:h-96 p-2 py-2 gap-y-3 rounded-lg flex flex-col items-start justify-start bg-[#00B3E1] bg-opacity-20 shadow-lg hover:bg-transparent hover:border hover:text-[#00B3E1] duration-200">
              <h3 className="font-semibold text-lg md:text-2xl">{card.title}</h3>
              <p className="text-base md:text-lg tracking-wide">{card.description}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default SolutionCard;
